import type { FaireProductEntity } from "../../entity_types/product";

export const p_m4rzkc9nzm: FaireProductEntity = {
  token: "p_m4rzkc9nzm",
  type: "product",
  name: "The New Gang",
  brandToken: "b_2zlerrpi5b",
  brandName: "Subtle Tea",
  imageUrl:
    "https://cdn.faire.com/fastly/9ead0781a3a2f035b9afb627304e2771f16840cd4b66d59053cab4b40d66fc86.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e48f73bb0fadd3d979a556463a0c0ce0f827b908233f748169c7bc37284e3d8f.jpeg",
    "https://cdn.faire.com/fastly/3926eaca89766d4ca9467a36f10aeeeceaa746f166fbb71672704fa9340c3a3d.jpeg",
    "https://cdn.faire.com/fastly/68b09e6a0ea192257e53dd066010050f5ca27b869a36881c165986217d8d3955.jpeg",
    "https://cdn.faire.com/fastly/52912f47c38bbc929c7b16659f5528f50c9a649052c2b67632d9e4a773181222.jpeg",
    "https://cdn.faire.com/fastly/8e28f14e484a0e9d50e9f6fe576f16945f47b0f1ad866bdb38342111ab635cc3.jpeg",
    "https://cdn.faire.com/fastly/b1712cd9c454efc6ca55e4b47e660a7d8dec6788caae7de9d50781434c93f65b.jpeg",
  ],
  priceDollars: 44.33,
  description:
    "The New Gang is a mixed case with 4 of each of the new flavors.\n\n4 - Oh Honey - Black Tea & Lemon\n4 - Oh Honey - Green Tea\n4 - Real Lemonade",
  tags: [],
  msrpDollars: 88.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:50.917Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
